import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useImperativeHandle, useId, } from 'react';
import classnames from 'classnames';
import * as styles from './CheckTemplate.module.scss';
export const CheckTemplate = ({ ref, children, className, inputClassName, labelClassName, disabled, id: propId, title, type, indeterminate, onChange, onToggle, ...rest }) => {
    const generatedId = `check${useId()}`;
    const id = propId || generatedId;
    const testId = rest['data-testid'];
    const localRef = useRef(null);
    useImperativeHandle(ref, () => localRef?.current);
    const handleChange = useCallback((event) => {
        onChange?.(event);
        onToggle?.(event.currentTarget.checked);
    }, [onChange, onToggle]);
    useEffect(() => {
        if (localRef?.current) {
            localRef.current.indeterminate = Boolean(indeterminate);
        }
    }, [ref, indeterminate]);
    return (_jsxs("div", { className: classnames('u-position-relative', className), "data-testid": testId && `${testId}-container`, children: [_jsx("input", { ...rest, ref: localRef, className: classnames(styles.input, inputClassName), disabled: disabled, id: id, type: type, onChange: !disabled ? handleChange : undefined }), _jsx("label", { className: labelClassName, "data-testid": testId && `${testId}-label`, htmlFor: id, title: title, children: children })] }));
};
//# sourceMappingURL=CheckTemplate.js.map